import { render, staticRenderFns } from "./DeliveryPointList.vue?vue&type=template&id=649949ef"
import script from "./DeliveryPointList.js?vue&type=script&lang=js&external"
export * from "./DeliveryPointList.js?vue&type=script&lang=js&external"
import style0 from "./DeliveryPointList.vue?vue&type=style&index=0&id=649949ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports